import { render, staticRenderFns } from "./setPwdDc.vue?vue&type=template&id=e2849450&scoped=true"
import script from "./setPwdDc.vue?vue&type=script&lang=js"
export * from "./setPwdDc.vue?vue&type=script&lang=js"
import style0 from "./setPwdDc.vue?vue&type=style&index=0&id=e2849450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2849450",
  null
  
)

export default component.exports